import { Component, Input, OnInit } from '@angular/core';
import { MovieModel, PersonModel } from '../../core/interfaces/movie.model';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { randomInt } from 'crypto';
import { ParametersService } from 'src/app/core/services/parameters.service';
import { ParameterModel } from 'src/app/core/interfaces/parameter.model';

@Component({
  selector: 'app-ui-poster',
  templateUrl: './ui-poster.component.html',
  styleUrls: ['./ui-poster.component.scss']
})
export class UiPosterComponent implements OnInit {
  @Input() movie: MovieModel;
  @Input() mostrarInfo: boolean;

  nombreCompletoDirector = '';
  fotoPrincipal = '';
  movieLink = '';
  selectedDirector: PersonModel;

  PARAMS: ParameterModel;

  esEstreno = false;
  esCinema = false;
  isFree = false;

  constructor(private router: Router, private parametersService: ParametersService) { }

  async ngOnInit() {
    await this.parametersService.getAllParameters().then((res) => {
      this.PARAMS = res;
    });

    // cocardas: free -> estreno -> en sala
    if (this.movie.paymentOption == 0) {
      this.isFree = true;
    }

    if (!this.isFree) {
      this.esEstreno = this.movie.categories.find((c) => {
        return c.id === parseInt(this.PARAMS.ESTRENOS_ID.value);
      }) ? true : false;

      if (!this.esEstreno) {
        this.esCinema = this.movie.categories.find((m) => {
          return m.id === parseInt(this.PARAMS.CINEMA_ID.value);
        }) ? true : false;
      }
    }

    if (this.movie.directors != null) {
      if (this.movie?.directors.length > 0) {
        this.selectedDirector = this.movie?.directors[this.getRandomInt(0, this.movie?.directors.length - 1)];
        this.selectedDirector.fullName = this.selectedDirector.name + (this.selectedDirector.lastName ? " " + this.selectedDirector.lastName : "");
      }
    }

    let poster = this.movie.pictures.find((picture) => picture.isPoster == true);
    let fotoP = poster ? poster : this.movie.pictures.find((picture) => picture.isDefault == true);

    const temas = ['animals', 'architecture', 'nature', 'people', 'tech'];

    this.fotoPrincipal = fotoP
      ? environment.apiEndpoint + fotoP.pictureLink
      : // : './assets/img/2019_3_7_18_47_450000073.jpg';

      // Se agrega una imagen random solamente para probar en desarrollo
      'http://placeimg.com/640/480/' + temas[Math.floor(Math.random() * temas.length)];

    this.movieLink = "/movie/" + this.movie.id;

  }

  goMovie($event: MouseEvent, idMovie) {
    $event.preventDefault();

    this.router.navigate(['/movie', idMovie]);
  }

  getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

}
